<a href="javascript:;" (click)="followingTopic(topic.slug) ? unfollowTopic(topic.slug) : followTopic(topic.slug)"  [attr.aria-label]="'Follow ' + topic.name" class="topic" *ngFor="let topic of availableTopics" [class.active]="followingTopic(topic.slug)">
    <div class="thumbnail-box" [responsiveBackgroundImage]="topic.thumbnail_square">
        <div class="followed-overlay">
            <div class="check">
                <i class="fas fa-check-square"></i>
            </div>
        </div>
    </div>
    
    <div class="label">{{topic.name}}</div>
</a>
